var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDept(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5 13.1665C7.17123 14.2606 9.56869 14.8305 12 14.8305C14.4313 14.8305 16.8288 14.2606 19 13.1665",
    stroke: "#4F46E5",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5 10.0551C5 9.64251 5.16389 9.24685 5.45561 8.95512C5.74733 8.6634 6.143 8.49951 6.55556 8.49951H17.4444C17.857 8.49951 18.2527 8.6634 18.5444 8.95512C18.8361 9.24685 19 9.64251 19 10.0551V17.0551C19 17.4676 18.8361 17.8633 18.5444 18.155C18.2527 18.4467 17.857 18.6106 17.4444 18.6106H6.55556C6.143 18.6106 5.74733 18.4467 5.45561 18.155C5.16389 17.8633 5 17.4676 5 17.0551V10.0551Z",
    stroke: "#172B4D",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.88867 8.50027V6.94472C8.88867 6.53216 9.05256 6.13649 9.34428 5.84477C9.63601 5.55305 10.0317 5.38916 10.4442 5.38916H13.5553C13.9679 5.38916 14.3636 5.55305 14.6553 5.84477C14.947 6.13649 15.1109 6.53216 15.1109 6.94472V8.50027",
    stroke: "#172B4D",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12 12.3892V12.3979",
    stroke: "#4F46E5",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDept);
export default __webpack_public_path__ + "static/media/dept.03e4bb57d6b3bda6a78f800981f712d5.svg";
export { ForwardRef as ReactComponent };